import { ARTIST_EDITS_SLA, artistEditsSlaLines } from "common/artist-edits-sla";
import type { ArtistEditsSla } from "common/artist-edits-sla";

// MN-4816: Presentational SLA disclosure for the "Need artist edits? FREE"
// feature. The caller is responsible for the Flip-flag gate; this component only
// renders confirmed SLA lines from the single `ARTIST_EDITS_SLA` config point.
// When nothing is confirmed yet it renders a claim-free, zero-footprint
// placeholder container (so the wiring stays observable once the flag is on)
// without inventing an SLA or leaving an empty styled gap.

type ArtistEditsSlaDisclosureProps = {
  sla?: ArtistEditsSla;
  className?: string;
  lineClassName?: string;
};

export function ArtistEditsSlaDisclosure({
  sla = ARTIST_EDITS_SLA,
  className = "space-y-0.5 text-xs leading-tight text-gray-600",
  lineClassName
}: ArtistEditsSlaDisclosureProps) {
  const lines = artistEditsSlaLines(sla);

  // Apply the surface's spacing/styling only when there is something to show, so
  // an enabled-but-unconfirmed flag leaves no empty styled gap (e.g. a stray
  // top margin) in the layout. role="note" gives screen readers the customer-
  // promise context once a confirmed line renders (omitted while empty).
  return (
    <div
      data-testid="artist-edits-sla-disclosure"
      role={lines.length > 0 ? "note" : undefined}
      className={lines.length > 0 ? className : undefined}
    >
      {lines.map(line => (
        <p key={line} className={lineClassName} data-testid="artist-edits-sla-line">
          {line}
        </p>
      ))}
    </div>
  );
}
